module.exports = __webpack_public_path__ + "img/login_ic_phone.f114156.png";